import { createContext } from 'react'

import type {
  CMSCollectionFilter,
  CMSCollectionFilterGroup,
  CMSCollectionFilterLink,
  CMSCollectionGridItem,
  CMSCollectionSortBy,
  CMSSortBy,
} from '@/types/sanity'

/* eslint-disable no-unused-vars */
export type CollectionContextType = {
  filters: CMSCollectionFilterGroup[]
  activeGridItems: CMSCollectionGridItem[]
  appliedFilters: Record<string, CMSCollectionFilter>
  collectionLinks: CMSCollectionFilterLink[]
  sortby?: CMSCollectionSortBy
  appliedSorting?: CMSSortBy
  isFilterApplied: ({
    filter,
    filterGroup,
  }: {
    filter: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => boolean
  isFilterAvailable: ({
    filter,
    filterGroup,
  }: {
    filter: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => boolean
  handleFilterChange: ({
    filter,
    filterGroup,
  }: {
    filter?: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => void
  setAppliedFilters: (filters: Record<string, CMSCollectionFilter>) => void
  setAppliedSorting: (sortOption: CMSSortBy) => void
}

export const CollectionContext = createContext({} as CollectionContextType)
